import api from '../apiClient';

// ITBMS working paper (DGI Formulario 430). Backend: /api/tax-reports/itbms
const base = '/tax-reports/itbms';

export const getItbmsSettings = () => api.get(`${base}/settings`);
export const updateItbmsSettings = (data) => api.put(`${base}/settings`, data);
export const getItbmsPeriods = () => api.get(`${base}/periods`);
export const getItbmsReport = (period) => api.get(`${base}/${period}`);
export const saveItbmsAdjustments = (period, data) => api.put(`${base}/${period}/adjustments`, data);
export const presentItbmsPeriod = (period, data) => api.post(`${base}/${period}/present`, data);
export const reopenItbmsPeriod = (period) => api.post(`${base}/${period}/reopen`);
export const setPurchaseBuyerCheck = (orderId, status) => api.put(`${base}/purchases/${orderId}/buyer-check`, { status });
export const setSupplierPayeeType = (supplierId, payeeType) => api.put(`${base}/suppliers/${supplierId}/payee-type`, { payee_type: payeeType });
export const saveDgiControl = (period, data) => api.put(`${base}/${period}/dgi-control`, data);
